import React, { useState, useEffect } from "react";
import * as Yup from "yup";
import { Modal, Alert } from "react-bootstrap";
import { Field, Form, Formik } from "formik";
import { baseUrl } from "../../../services/config";
import { Link } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Select from "react-select";
import jwt_token from "../../../services/authToken";
import { useAlert } from "react-alert";
import { useSelector } from "react-redux";
import MySelect from "./../CustomChallan/MySelect";
import makeAnimated from "react-select/animated";
import { components } from "react-select";

const AddUserCampuses = ({ show, onHide, reload }) => {
  const alert = useAlert();
  const authToken = jwt_token();
  const user = useSelector((state) => state.user.user);

  const [loading, setLoading] = useState(false);
  const [isError, setIsError] = useState(false);
  const [errorsLis, setErrorsLis] = useState("");
  let [errorcreate, seterrorcreate] = useState("Please fill all fields");
  let [isallfields, setisallfields] = useState(false);
  const [addloading, setaddloading] = useState(false);

  const [usersData, setUsersData] = useState([]);
  const [usersArray, setUsersArray] = useState([]);
  const [campusesList, setCampusesList] = useState([]);
  const [classesList, setClassesList] = useState([]);
  const [sectionsList, setSectionsList] = useState([]);

  const [selectedUser, setSelectedUser] = useState("");
  const [campusIds, setCampusIds] = useState([]);
  const [classIds, setClassIds] = useState([]);
  const [sectionIds, setSectionIds] = useState([]);
  const [selectedCampuses, setSelectedCampuses] = useState([]);
  const [selectedClasses, setSelectedClasses] = useState([]);
  const [selectedSections, setSelectedSections] = useState([]);

  useEffect(() => {
    GetAllUsers();
    // getAllCampus();
  }, []);

  const GetAllUsers = async () => {
    await fetch(`${baseUrl}/users`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        setUsersData(data.payload);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  // const getAllCampus = async () => {
  //   await fetch(`${baseUrl}/campus`, {
  //     method: "GET",
  //     headers: {
  //       Authorization: `Bearer ${authToken}`,
  //     },
  //   })
  //     .then((res) => res.json())
  //     .then((data) => {
  //       let arr = [];

  //       data.payload.forEach((element) => {
  //         arr.push({
  //           label: element.name,
  //           value: element.id,
  //         });
  //       });
  //       setCampusesList(arr);
  //     })
  //     .catch((err) => {
  //       console.log("campus", err);
  //     });
  // };

  const getUserCampusesClasses = (campusIds) => {
    if (!campusIds || campusIds.length === 0) {
      return alert.error("Please select at least one campus");
    }

    let data = {
      campus_ids: campusIds,
    };

    fetch(`${baseUrl}/campuses-classes`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${authToken}`,
      },

      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((data) => {
        let arr = [];

        data.payload.forEach((element) => {
          arr.push({
            label:
              element?.student_class?.name + " (" + element?.campus?.name + ")",
            student_class_id: element?.student_class_id,
            campus_id: element?.campus_id,
            value: element.id,
          });
        });
        setClassesList(arr);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const getClassSections = (classIds) => {
    if (campusIds.length == 0 || classIds.length == 0) {
      return alert.error("Please select at least one campus or class");
    }

    let data = {
      campus_ids: campusIds,
      student_class_ids: classIds,
    };

    fetch(`${baseUrl}/campuses-classes-sections`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${authToken}`,
      },

      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((data) => {
        let arr = [];

        data.payload.forEach((element) => {
          arr.push({
            label:
              element?.section?.name +
              " (" +
              element?.class?.name +
              " - " +
              element?.campus?.name +
              " )",
            student_class_id: element?.student_class_id,
            global_section_id: element?.global_section_id,
            value: element.id,
          });
        });
        setSectionsList(arr);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const AddUserCampusesHandle = async () => {
    if (
      campusIds.length == 0 ||
      classIds.length == 0 ||
      sectionIds.length == 0 ||
      usersArray.length == 0 ||
      selectedUser == ""
    ) {
      setisallfields(true);
      setLoading(false);
      return;
    }
    let data = {
      users: usersArray,
    };

    setaddloading(true);

    fetch(`${baseUrl}/user-campuses-classes-sections`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${authToken}`,
      },

      body: JSON.stringify(data),
    })
      .then((res) =>
        res.json().then((data) => {
          if (data.metadata.success) {
            disableLoading();
            setisallfields(false);
            setaddloading(false);
            setSelectedUser("");
            setUsersArray([]);
            setCampusIds([]);
            setCampusIds([]);
            setSectionIds([]);
            setSelectedCampuses([]);
            setSelectedClasses([]);
            setSelectedSections([]);
            alert.success("User Campus Successfully Added");
            reload();
            onHide(false);
          } else if (data.metadata.message) {
            alert.error(data.metadata.message);
            disableLoading();
            setisallfields(false);
            setaddloading(false);
            seterrorcreate("");
            onHide(false);
          }
        })
      )
      .catch((err) => {
        disableLoading();
        setisallfields(false);
        setaddloading(false);
        seterrorcreate("");
        alert.error(err);

        onHide(false);
      });
  };

  const enableLoading = () => {
    setLoading(true);
  };

  const disableLoading = () => {
    setLoading(false);
  };

  const animatedComponents = makeAnimated();
  const Option = (props) => {
    return (
      <div>
        <components.Option {...props}>
          <input
            type="checkbox"
            checked={props.isSelected}
            onChange={() => null}
          />{" "}
          <label>{props.label}</label>
        </components.Option>
      </div>
    );
  };

  const MultiValue = (props) => (
    <components.MultiValue {...props}>
      <span>{props.data.label}</span>
    </components.MultiValue>
  );

  const handleUserChange = (value) => {
    const newUser = {
      user_id: value,
      campuses: [],
    };
    console.log(newUser, "newUser at user change");
    // Overwrite the entire array with just the one selected user
    setUsersArray([newUser]);
    setSelectedUser(value);
  };

  const handleCampusChange = (selected) => {
    setSelectedCampuses([...selected]);

    // Extract campus IDs
    const valuearray = selected.map((item) => item.value);
    console.log(valuearray, "filtered campus array");

    // Update only the selected user's campuses
    const updatedUsersArray = usersArray.map((user) => {
      if (user.user_id === selectedUser) {
        const campuses = selected.map((campus) => ({
          campus_id: campus.value,
          classes: [], // initialize empty
        }));

        return { ...user, campuses };
      }
      return user;
    });

    console.log(updatedUsersArray, "filtered campus array");
    setUsersArray(updatedUsersArray);
    setCampusIds(valuearray);
    getUserCampusesClasses(valuearray);
  };

  const handleClassChange = (campusIds, selectedClasses) => {
    console.log("Selected classes:", selectedClasses);
    console.log("Selected campusIds:", campusIds);

    setSelectedClasses([...selectedClasses]);

    const valuearray = selectedClasses.map((item) => item.student_class_id); // Extract class IDs
    setClassIds(valuearray);
    getClassSections(valuearray);

    const campusClassMap = [];
    selectedClasses.forEach((cls) => {
      const campusId = cls.campus_id;
      if (!campusClassMap[campusId]) {
        campusClassMap[campusId] = [];
      }
      campusClassMap[campusId].push({
        class_id: cls.student_class_id,
        section_ids: [],
      });
    });

    const updatedUsersArray = usersArray.map((user) => {
      if (user.user_id == selectedUser) {
        const updatedCampuses = user.campuses.map((campus) => {
          if (campusClassMap[campus.campus_id]) {
            return {
              ...campus,
              classes: campusClassMap[campus.campus_id],
            };
          }
          return campus;
        });

        return { ...user, campuses: updatedCampuses };
      }
      return user;
    });

    console.log("Updated users array:", updatedUsersArray);
    setUsersArray(updatedUsersArray);
  };

  const handleSectionChange = (campusIds, classIds, selected) => {
    console.log("Selected campusIds:", campusIds);
    console.log("Selected classIds:", classIds);
    console.log("Selected Sections:", selected);

    setSelectedSections([...selected]);

    // Extract global_section_id values
    const sectionIdArray = selected.map((item) => item.global_section_id);
    setSectionIds(sectionIdArray);

    // Step 1: Group section_ids by class_id
    const classSectionMap = {};

    selected.forEach((item) => {
      const classId = item.student_class_id;
      const sectionId = item.global_section_id;

      if (!classSectionMap[classId]) {
        classSectionMap[classId] = [];
      }
      classSectionMap[classId].push(sectionId);
    });

    console.log("Grouped class-section map:", classSectionMap);

    // Map and update user object deeply
    const updatedUsersArray = usersArray.map((user) => {
      if (user.user_id === selectedUser) {
        const updatedCampuses = user.campuses.map((campus) => {
          if (campusIds.includes(campus.campus_id)) {
            const updatedClasses = campus.classes.map((cls) => {
              if (classIds.includes(cls.class_id)) {
                return {
                  ...cls,
                  section_ids: classSectionMap[cls.class_id],
                };
              }
              return cls;
            });

            return {
              ...campus,
              classes: updatedClasses,
            };
          }
          return campus;
        });

        return {
          ...user,
          campuses: updatedCampuses,
        };
      }
      return user;
    });

    console.log("Updated users array:", updatedUsersArray);
    setUsersArray(updatedUsersArray);
  };

  return (
    <Modal size="lg" show={show} aria-labelledby="example-modal-sizes-title-lg">
      <Modal.Header className="modal_header_style" closeButton>
        <Modal.Title
          className="Modal_Heading_font"
          id="contained-modal-title-vcenter"
        >
          Add User Campuses
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>
        {addloading ? (
          <b style={{ color: "green" }}>
            New User Adding Please Wait {` `}{" "}
            <span className="spinner-border"></span>
          </b>
        ) : (
          <div>
            <div className="form-group row">
              <div className="col-lg-6">
                <label className="form-label">
                  <b>Select User</b> <span style={{ color: "red" }}> *</span>
                </label>
                <select
                  className="form-select"
                  name="user_id"
                  style={{ height: 37 }}
                  aria-label="Default select example"
                  value={selectedUser || ""}
                  onChange={(e) => {
                    const selectedId = e.target.value;
                    const selectedObj = usersData.find(
                      (user) => user.id == selectedId
                    );

                    if (selectedObj) {
                      handleUserChange(selectedId); // pass full object

                      // Extract campuses and set list
                      const campusesTemp = selectedObj.campuses.map((item) => ({
                        value: item.id,
                        label: item.name,
                      }));

                      setCampusesList(campusesTemp);
                    }
                  }}
                >
                  <option value="">Select User</option>
                  {usersData &&
                    usersData.map((item, index) => (
                      <option key={index} value={item.id}>
                        {item.first_name + " " + item.last_name}
                      </option>
                    ))}
                </select>
              </div>
              <div className="col-lg-6">
                <label>
                  <b>Select Campuses</b>{" "}
                  <span style={{ color: "red" }}> *</span>
                </label>
                <MySelect
                  isMulti
                  value={selectedCampuses}
                  onChange={(newVal) => handleCampusChange(newVal)}
                  options={campusesList}
                  closeMenuOnSelect={true}
                  hideSelectedOptions={false}
                  name="selectedCampuses"
                  components={{
                    Option,
                    MultiValue,
                    animatedComponents,
                  }}
                  allowSelectAll={true}
                />
              </div>
            </div>

            <div className="form-group row">
              <div className="col-lg-6">
                <label className="form-label">
                  <b>Select Classes</b> <span style={{ color: "red" }}> *</span>
                </label>
                <MySelect
                  isMulti
                  value={selectedClasses}
                  onChange={(newVal) => handleClassChange(campusIds, newVal)}
                  options={classesList}
                  closeMenuOnSelect={true}
                  hideSelectedOptions={false}
                  name="selectedClasses"
                  components={{
                    Option,
                    MultiValue,
                    animatedComponents,
                  }}
                  allowSelectAll={true}
                />
              </div>
              <div className="col-lg-6">
                <label>
                  <b>Select Sections</b>{" "}
                  <span style={{ color: "red" }}> *</span>
                </label>
                <MySelect
                  isMulti
                  value={selectedSections}
                  onChange={(newVal) =>
                    handleSectionChange(campusIds, classIds, newVal)
                  }
                  options={sectionsList}
                  closeMenuOnSelect={true}
                  hideSelectedOptions={false}
                  name="selectedSetions"
                  components={{
                    Option,
                    MultiValue,
                    animatedComponents,
                  }}
                  allowSelectAll={true}
                />
              </div>
            </div>

            {isallfields ? (
              <>
                <Alert
                  variant="danger"
                  onClose={() => setisallfields(false)}
                  dismissible
                >
                  <Alert.Heading>Oh snap! You got an error!</Alert.Heading>
                  <p>{errorcreate}</p>
                </Alert>
              </>
            ) : null}

            <br />
            <div className="d-flex justify-content-end">
              <button
                className="btn btn-primary mx-4"
                onClick={() => AddUserCampusesHandle()}
                disabled={loading}
              >
                Submit
              </button>

              <ToastContainer
                position="top-right"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
              />

              <Link to="/user-campuses">
                <button
                  onClick={() => {
                    setisallfields(false);
                    setUsersArray([]);
                    setCampusIds([]);
                    setClassIds([]);
                    setSectionIds([]);
                    setSelectedCampuses([]);
                    setSelectedClasses([]);
                    setSelectedSections([]);
                    setSelectedUser("");
                    onHide(false);
                  }}
                  type="button"
                  className="btn btn-danger"
                >
                  Cancel
                </button>
              </Link>
            </div>
          </div>
        )}
      </Modal.Body>
    </Modal>
  );
};

export default AddUserCampuses;
